/* eslint-disable @typescript-eslint/naming-convention */
import { copy } from '../dom-utils/copyText';
import getReolinkLangByCookie from '../shared/getReolinkLangByCookie';
import getGlobal from '../shared/getGlobal';
import { pageInfo } from '@reolink-deps/reolink-web_multisite-utils';

interface IWinWithCopyTag extends Window{
    // 是否已经添加了复制文本的监听事件
    __isAddCopyTextEvent: boolean;
}
const win = getGlobal() as unknown as IWinWithCopyTag;
const copyableREG = /\[copyable(?:=(.*?))?\](.*?)\[\/copyable\]/;
const copyableAllREG = new RegExp(copyableREG, 'g');
const COPY_SUCCESS_SPAN_CLASS = '__ubb_copy_text__';

// 客户端初始化语言
if (win?.document) {
    pageInfo.setLanguage(getReolinkLangByCookie());
}

const copyTextI18nMap: Record<string, string> = {
    'en': 'Copy',
    'de': 'kopieren',
    'fr': 'Copier',
    'it': 'Copia',
    'es': 'Copiar',
    'pt': 'Copiar',
    'jp': 'コピー'
};
const copiedTextI18nMap: Record<string, string> = {
    'en': 'Copied!',
    'de': 'Kopiert!',
    'fr': 'Copié!',
    'it': 'Copiato!',
    'es': 'Copiado!',
    'pt': 'Copiado!',
    'jp': 'コピー済み'
};
/**
 * 增加对指定类名元素的监听，点击元素时复制innerText,并在文字旁添加复制成功提示
 * @param className 元素类名
 * @param successTips 复制成功的提示默认为 `copied !`
 * @returns 
 */
export function addCopyTextEvent(className: string, copiedTips: string): void {

    if (win?.document && !win.__isAddCopyTextEvent  ) {
        // 需要绑定在window上，避免一个页面有多个组件可复制导致重复监听
        win.__isAddCopyTextEvent  = true;
        document.body.addEventListener('click', (e: MouseEvent) => {
            const target = e.target as HTMLSpanElement;
            if (!target) {
                return;
            }
            if (target.classList?.contains(className)) {
                try {
                    copy(target.getAttribute('data-text') ?? '');
                    // 复制完成后修改提示
                    target.innerHTML = copiedTips;
                }
                catch (err) {
                    console.error(err);
                }
                
            }
        });
    }
    return;
}

/**
 * 处理ubb文字中的 含有copyable标签的元素，监听点击，触发复制文字操作
 * @param text 原文本
 * @param successTips 
 * @returns 
 */
function handelCopyText(text: string): string {
    if (!copyableREG.test(text)) {
        return text;
    }
    else {
        const lang = pageInfo.getLanguage();
        const copyText = copyTextI18nMap[lang] ?? copyTextI18nMap['en'];
        const copiedText = copiedTextI18nMap[lang] ?? copiedTextI18nMap['en'];
        if (win?.document) {
            addCopyTextEvent(COPY_SUCCESS_SPAN_CLASS, copiedText);
        }
        const res = text.replace(copyableAllREG, (...targets) => {
            const style = targets[1];
            const value = targets[2];
            return `
            <span>
                ${value}
                <span 
                    style="text-decoration: underline;text-decoration-style: solid;font-size: 0.5em;color: #0E6AFF;font-family: inherit;vertical-align: top;line-height: initial;${style}"
                    class="${COPY_SUCCESS_SPAN_CLASS}"
                    data-text="${value}"
                    >
                    ${copyText}
                </span>
            </span>
            `;
        });
        return res;
    }
}

export default handelCopyText;
